<div class="po-row np" style="margin-top: 18px;">
  <po-widget class="po-xl-12 po-lg-12 po-md-12 po-sm-12" [p-no-shadow]="true">

    <p class="cp-color-title ">{{ this.literalsCp?.strQuantidade | uppercase }}</p>

    <div style="margin-top: 1.5em;">

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" style="width: 18em;height: 10em">
        <cp-input-quantity-cost [inputCost]="inputCost" [isHideLoading]="isHideLoadingCost"></cp-input-quantity-cost>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3">
        <cp-input-quantity-order [inputQuantityOrder]="inputQuantityOrder" [isHideLoading]="isHideLoadingOrder"></cp-input-quantity-order>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3"  style="margin-top: 5px">
        <cp-input-quantity-contract [inputQuantityContract]="inputValueContract" [isHideLoading]="isHideLoadingContract"></cp-input-quantity-contract>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"  style="margin-top: 5px"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3">
        <cp-input-quantity [inputQuantity]="inputValue" [isHideLoading]="isHideLoadingValueQuantity"></cp-input-quantity>
      </div>

    </div>

  </po-widget>
</div>

<div class="po-row np">
  <po-widget class="po-xl-12 po-lg-12 po-md-12 po-sm-12" [p-no-shadow]="true">

    <p class="cp-color-title ">{{ this.literalsCp?.strValor | uppercase }}</p>

    <div style="margin-top: 1.5em;">

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" style="width: 18em;height: 10em">
          <cp-input-value-cost [inputCost]="inputCost" [isHideLoading]="isHideLoadingCost"></cp-input-value-cost>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3"  style="margin-top: 5px">
        <cp-input-value-order [inputQuantityOrder]="inputQuantityOrder" [isHideLoading]="isHideLoadingOrder"></cp-input-value-order>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3"  style="margin-top: 5px">
        <cp-input-value-contract [inputValueContract]="inputValueContract" [isHideLoading]="isHideLoadingContract"></cp-input-value-contract>
      </div>

      <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

      <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3">
        <cp-input-value [inputValue]="inputValue" [isHideLoading]="isHideLoadingValueQuantity"></cp-input-value>
      </div>

    </div>

  </po-widget>
</div>
